import React from "react";
import Icon from "components/AppIcon";

const DividendInfo = ({ dividends }) => (
  <div className="bg-card border border-border rounded-xl p-4 md:p-5">
    <div className="flex items-center gap-2 mb-4">
      <Icon name="Gift" size={16} color="var(--color-accent)" />
      <span className="font-heading text-sm font-semibold text-foreground">Dividend Information</span>
    </div>

    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
      {[
        { label: "Annual Yield", value: dividends?.yield, highlight: true },
        { label: "Per Share", value: dividends?.perShare },
        { label: "Payout Ratio", value: dividends?.payoutRatio },
        { label: "Frequency", value: dividends?.frequency },
      ]?.map(item => (
        <div key={item?.label} className="bg-secondary/60 rounded-lg p-3 border border-border/50 text-center">
          <div className="text-xs text-muted-foreground font-caption mb-1">{item?.label}</div>
          <div className={`font-heading text-sm font-bold ${item?.highlight ? "" : "text-foreground"}`}
            style={item?.highlight ? { color: "var(--color-accent)" } : {}}>
            {item?.value}
          </div>
        </div>
      ))}
    </div>

    <div className="space-y-2">
      <div className="text-xs text-muted-foreground font-caption uppercase tracking-wider mb-2">Payment Schedule</div>
      {dividends?.schedule?.map((s, i) => (
        <div key={i} className="flex items-center justify-between py-2 border-b border-border/40 last:border-0">
          <div className="flex items-center gap-2">
            <div className={`w-2 h-2 rounded-full ${s?.paid ? "bg-success" : "bg-muted"}`}
              style={{ background: s?.paid ? "var(--color-success)" : "var(--color-muted-foreground)" }} />
            <span className="text-sm text-foreground font-caption">{s?.date}</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-muted-foreground">{s?.type}</span>
            <span className="font-heading text-sm font-semibold" style={{ color: "var(--color-accent)" }}>{s?.amount}</span>
            {s?.paid && <span className="text-xs px-1.5 py-0.5 rounded font-caption"
              style={{ background: "rgba(16,185,129,0.1)", color: "var(--color-success)" }}>PAID</span>}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default DividendInfo;